import { ACCESS_CODE_COOKIE_NAME } from './constants'

const setAccessCookie = accessCode => {
  document.cookie = `${ACCESS_CODE_COOKIE_NAME}=${accessCode};path=/;domain=.plurall.net`
}

const clearAccessCodeFromCookies = () => {
  document.cookie = `${ACCESS_CODE_COOKIE_NAME}="";path=/;domain=.plurall.net;expires=Thu, 01 Jan 1970 00:00:00 GMT`
}

export { setAccessCookie, clearAccessCodeFromCookies }
